<template>

  <div class="box-message">
    <transition name="fade" mode="out-in">
      <div v-if="!investDataStatus && !investTermsStatus">
        <h3 class="title">Detalles de tu inversión:</h3>
        <div class="box-message-details">
          <div class="simulation-investment-resume -centered-info -background-dark">
            <div class="row row-responsive">
              <div class="column column-sm-33 -padding-right">
                <span class="title">Tasa</span>
                <span class="value">{{ formatPercentage(object.rate) }}</span>
              </div>
              <div class="column column-sm-33 -padding-left-right">
                <span class="title">Monto inversión:</span>
                <span class="value">{{ formatCurrency($store.getters.getSimulatedValues.amountInvest) }}</span>
              </div>
              <div class="column column-sm-33 -padding-left">
                <span class="title">Monto a transferir:</span>
                <span class="value">{{ formatCurrency($store.getters.getSimulatedValues.simulatedNetInvestment) }}</span>
              </div>
            </div>
          </div>
          <div class="row row-responsive">
            <div class="column column-sm-80 column-offset-sm-10">
              <h5 class="-margin-bottom-1">Costos de la inversión:</h5>
              <ul class="simulation-investment-detail">
                <li>
                  <b>Comisión Cumplo:</b> {{ formatCurrency($store.getters.getSimulatedValues.simulatedUpfrontFee) }}
                  <span class="legend">Cobrado al inicio de la inversión.</span>
                </li>
                <li>
                  <b>Cobro por cobranza:</b> {{ formatCurrency($store.getters.getSimulatedValues.simulatedCollectionFee) }}
                  <span class="legend">Se descontará de los intereses una vez liquidado el crédito.</span>
                </li>
              </ul>
              <h5 class="-margin-bottom-1">Retorno de la inversión:</h5>
              <ul class="simulation-investment-detail">
                <li><b>Plazo estimado de retorno de la inversión:</b> {{ object.duration }} días</li>
                <li><b>Monto bruto:</b> {{ formatCurrency($store.getters.getSimulatedValues.simulatedInstallment) }}</li>
                <li><b>Utilidad neta al fin del crédito:</b> {{ formatCurrency($store.getters.getSimulatedValues.simulatedNetInstallment - $store.getters.getSimulatedValues.simulatedNetInvestment)  }}</li>
              </ul>
              <div class="simulation-investment-buttons">
                <button class="button" @click="toggleInvestTerms()">Revisar términos de inversión</button>
                <button class="button button-outline" @click.prevent="$modal.hide('want-to-invest');">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="investTermsStatus && !investDataStatus">
        <h3 class="title">Detalles de tu inversión:</h3>
        <div class="horizontal-responsive">
          <table class="simulation-investment-detail">
            <tr>
              <th>Amortización N°</th>
              <th>Capital</th>
              <th>Interés *</th>
              <th>Costo cobranza</th>
              <th>Monto a recibir</th>
              <th>Fecha vencimiento **</th>
            </tr>
            <tr>
              <td>1</td>
              <td>{{ formatCurrency($store.getters.getSimulatedValues.amountInvest) }}</td>
              <td>{{ formatCurrency($store.getters.getSimulatedValues.simulatedInstallment - $store.getters.getSimulatedValues.amountInvest) }}</td>
              <td>{{ formatCurrency($store.getters.getSimulatedValues.simulatedCollectionFee) }}</td>
              <td>{{ formatCurrency($store.getters.getSimulatedValues.simulatedInstallment - $store.getters.getSimulatedValues.simulatedCollectionFee) }}</td>
              <td>{{ format(object.payment_date, 'DD/MM/YYYY')  }}</td>
            </tr>
          </table>
        </div>
        <transition name="fade">
          <div class="simulation-investment-virtualaccount" v-if="showVirtualAccountOption">
            <p class="subtitle"><img src="/static/svg/icon_entypo-info-with-circle-invest.svg">{{ virtualAccountText }}</p>
            <label class="input checkbox">{{ virtualAccountLabel }}
              <input type="checkbox" v-model="isVirtual">
              <div class="indicator"></div>
            </label>
          </div>
        </transition>
        <div class="simulation-investment-required">
          <label class="input checkbox">Entiendo y acepto que este crédito no se encuentra garantizado por Cumplo y <b>declaro asumir el riesgo de no diversificar mi inversión, mora, incumplimiento y no pago por parte del deudor</b>. Cumplomex SA de CV no es una entidad supervisada por organismos reguladores en México ***.
            <input type="checkbox" :checked="requiredCheckbox" v-model="requiredCheckbox">
            <div class="indicator"></div>
          </label>
        </div>
        <div class="box-validatecode" v-if="!savingData">
          <div class="row">
            <div class="column column-50 column-offset-25">
              <MFAHandler button="hideButton" v-on:tokenObtained="onClickedChild"></MFAHandler>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div class="simulation-investment-buttons" v-if="savingData">
            <button class="button" @click="sendInvestData(investToken)" :disabled="!requiredCheckbox || investToken === null">
              Confirmar inversión
              <WaitingButton v-if="investmentConfirmation"></WaitingButton>
            </button>
            <button class="button button-outline" @click="toggleInvestTerms()" :disabled="investmentConfirmation">Volver</button>
          </div>
        </transition>
        <div class="box-legend">
          <p>* Los intereses de este crédito comenzarán a generarse el día en que se financie.</p>
          <p>** Los valores y fechas de pago son estimados. El desarrollo definitivo del crédito dependerá del día de firma de pagaré y estará disponible para los inversionistas en el detalle de cada una de sus inversiones.</p>
        </div>
      </div>
      <div v-if="investDataStatus && !investTermsStatus">
        <h3 class="title">Detalles de tu inversión:</h3>
        <div class="box-message-details">
          <div class="row row-responsive">
            <div class="column column-sm-10">
              <CheckmarkOK></CheckmarkOK>
            </div>
            <div class="column column-sm-90">
              <p class="-margin-top-1">
                Hemos recibido con éxito los detalles de tu inversión.
                <span
                  v-if="isVirtual && !hasDifferenceBalance">
                  Haremos el retiro de
                  <b>
                    {{ formatCurrency($store.getters.getSimulatedValues.simulatedNetInvestment) }}
                  </b>
                  de tu Cuenta Virtual para esta inversión.
                </span>
                <span
                  v-else-if="isVirtual && hasDifferenceBalance">
                  Para completarla, debes hacer una transferencia por el monto de
                  <b>
                    {{ formatCurrency(this.virtualAccountsBalance) }}
                  </b>
                  a la siguiente cuenta bancaria:
                </span>
                <span v-else>
                  Para completarla, debes hacer una transferencia por el monto de
                  <b>
                    {{ formatCurrency($store.getters.getSimulatedValues.simulatedNetInvestment) }}
                  </b>
                  a la siguiente cuenta bancaria:
                </span>
              </p>
            </div>
          </div>
          <div class="bank-details" v-if="!isVirtual || hasDifferenceBalance">
            <pre><code>{{ $store.getters.getFullUserName }}
RFC: {{ $store.getters.getUserRFC }}
Banco: {{ bank }}
CLABE: {{ $store.getters.getUserClabe }}</code></pre>
           <p class="-legend">* Las transferencias deben venir de una cuenta a tu nombre, no aceptamos transferencias de terceros.</p>
          </div>
          <p>Una vez realizada te notificaremos la confirmación de tu inversión. Siempre puedes contactarnos al e-mail <a href="mailto:contacto.mx@cumplo.com"><b>contacto.mx@cumplo.com</b></a> o llamarnos al teléfono <a href="tel:5571002310"><b>(55) 7100 2310</b></a>.</p>
          <h5 class="title">Detalle de la inversión:</h5>
          <div class="horizontal-responsive">
            <table class="simulation-investment-detail">
              <tr>
                <th>Amortización N°</th>
                <th>Capital</th>
                <th>Interés</th>
                <th>Costo cobranza</th>
                <th>Monto a recibir</th>
                <th>Fecha vencimiento</th>
              </tr>
              <tr>
                <td>1</td>
                <td>{{ formatCurrency($store.getters.getSimulatedValues.amountInvest) }}</td>
                <td>{{ formatCurrency($store.getters.getSimulatedValues.simulatedInstallment - $store.getters.getSimulatedValues.amountInvest) }}</td>
                <td>{{ formatCurrency($store.getters.getSimulatedValues.simulatedCollectionFee) }}</td>
                <td>{{ formatCurrency($store.getters.getSimulatedValues.simulatedInstallment - $store.getters.getSimulatedValues.simulatedCollectionFee) }}</td>
                <td>{{ format(object.payment_date, 'DD/MM/YYYY')  }}</td>
              </tr>
            </table>
          </div>
        </div>
        <button class="button -button-centered" @click.prevent="$modal.hide('want-to-invest'); $router.push('/')">Cerrar</button>
      </div>
    </transition>
    <a href="#" class="close" @click.prevent="$modal.hide('want-to-invest')">
      <img alt="Cerrar" src="/static/svg/icon_fontawesome-times-circle.svg">
    </a>
  </div>

</template>

<script>

import CheckmarkOK from '@/components/CheckmarkOK'
import WaitingButton from '@/components/WaitingButton'
import MFAHandler from '@/components/MFAHandler'

import Vue from 'vue'

import { format, addDays } from 'date-fns'
import {TheMask} from 'vue-the-mask'
import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'Simulator',
  data () {
    return {
      format,
      addDays,
      userEmail: null,
      userName: null,
      investTermsStatus: false,
      investDataStatus: false,
      requiredCheckbox: true,
      investmentConfirmation: false,
      showVirtualAccountOption: false,
      virtualAccountsBalance: 0,
      isVirtual: false,
      hasDifferenceBalance: false,
      virtualAccountText: '',
      virtualAccountLabel: '',
      investmentBalanceText: '',
      savingData: false,
      investToken: null,
      hideButton: true,
      bank: process.env.BUSINESS_BANK
    }
  },
  props: { 'object': Object },
  mixins: [mixins, httpRequestMixin],
  components: {
    CheckmarkOK,
    WaitingButton,
    TheMask,
    MFAHandler
  },
  methods: {
    toggleInvestTerms: function () {
      this.investTermsStatus = !this.investTermsStatus
    },
    checkVirtualAccountStatus: function () {
      this.virtualAccountsBalance = this.$store.getters.getUserBalance.balance
      const amountToInvest = this.$store.getters.getSimulatedValues.amountInvest
      if (this.virtualAccountsBalance >= amountToInvest) {
        this.virtualAccountText = 'Tu Cuenta Virtual tiene saldo disponible ' +
          'para esta inversión. ¿Quieres utilizarla?'
        this.virtualAccountLabel = 'Si, utilizar mi saldo de Cuenta Virtual.'
        this.virtualAccountsBalance =
          this.$store.getters.getSimulatedValues.amountInvest
        this.showVirtualAccountOption = true
      } else {
        this.virtualAccountsBalance =
          amountToInvest - this.virtualAccountsBalance
        this.virtualAccountText = 'Tienes saldo en tu Cuenta Virtual pero faltan ' +
          this.formatCurrency(this.virtualAccountsBalance) + ' para completar esta ' +
          'inversión. ¿Quieres depositar esta diferencia?'
        this.virtualAccountLabel = 'Si, depositaré la diferencia a mi Cuenta Virtual.'
        this.hasDifferenceBalance = true
        this.showVirtualAccountOption = true
      }
    },
    onClickedChild: function (token) {
      this.investToken = token
      this.savingData = true
    },
    sendInvestData: async function (token) {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/investments/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          'funding_request': this.object.id,
          'token': token,
          'amount': this.$store.getters.getSimulatedValues.amountInvest,
          'virtual': this.isVirtual
        }
      }

      this.investmentConfirmation = true
      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 201) {
          this.successInvest()
          this.investmentConfirmation = false
        } else if (response.status === 202) {
          const message = this.convertArraytoString(response.data)
          this.failedInvest(response.status, message.join('\n\r'))
        } else {
          this.failedInvest(response.status, response.data.join('\n\r'))
        }
      }
    },
    successInvest: function (errorCode) {
      if (errorCode) {
        Vue.swal({
          type: 'warning',
          title: '',
          text: this.errorCodes(errorCode),
          showCloseButton: true,
          showConfirmButton: true,
          confirmButtonColor: '#00ba68',
          confirmButtonText: 'Continuar'
        })
      }

      this.investTermsStatus = false
      this.investDataStatus = true
      this.investmentConfirmation = false
      this.investToken = null
    },
    failedInvest: function (errorCode, errorMessage = null) {
      Vue.swal({
        type: 'warning',
        title: '',
        text: errorMessage,
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#00ba68',
        confirmButtonText: 'Continuar'
      })

      this.investTermsStatus = false
      this.investDataStatus = false
      this.investmentConfirmation = false
      this.investToken = null
      this.savingData = false

      this.sendErrorToLogger(this.$options.name, errorMessage)
    }
  },
  created: async function () {
    this.userEmail = this.$store.getters.getEmail
    this.userName = this.$store.getters.getFullUserName
    this.investToken = null

    await this.getBalance()
    await this.getInvestorClabe()
    await this.getUserData()

    this.checkVirtualAccountStatus()
  }
}

</script>

<style lang="scss" scoped>

.box-message {
  padding: 4rem 3rem;

  .title {
    color: $midnight-blue;
    border-bottom: 1px solid #ccc;
    font-weight: normal;
  }

  .close {
    $offset: 15px;

    position: absolute;
    top: $offset;
    right: $offset;
  }

  .simulation-investment-detail {
    font-size: 1.4rem;

    li {
      padding: .5rem;
      text-align: right;

      &:not(:last-of-type) {
        border-bottom: 1px solid #ccc;
        margin-bottom: 0;
      }

      &:before {
        display: none;
      }

      b {
        display: block;
        float: left;
        with: 50%;
        text-align: left;
        font-weight: normal;
      }
    }

    th,
    td {
      text-align: center;
    }

    .legend {
      display: block;
      text-align: left;
      font-size: .85em;
      font-style: italic;
    }
  }

  .simulation-investment-resume {
    padding: 0 2rem;
    margin-bottom: 4rem;

    &.-background-dark {
      background-color: $midnight-blue;
      color: $white;
      border-radius: 6px;
    }

    .column {
      padding: 1rem 0 0;

      &:last-of-type {
        padding-bottom: 1rem;
      }
    }

    .title,
    .value {
      display: block;
    }
    .title {
      margin-bottom: .5rem;
      padding-bottom: .5rem;
      color: $white;
      font-size: .9em;
    }
    .value {
      font-weight: bold;
    }
  }

  .simulation-investment-virtualaccount {
    padding: 0 0 1.5rem 0;
    margin-bottom: 2rem;
    border-bottom: 1px solid $green;
    font-size: 1em;

    .subtitle {
      margin-bottom: .5rem;
      font-weight: bold;

      > img {
        margin: 0 5px -5px 0;
      }
    }

    > label {
      margin-bottom: 0;
      font-size: 1em;
    }
  }

  .simulation-investment-required {

    > label {
      font-size: .8em;
    }
  }

  .simulation-investment-buttons {
    text-align: center;

    .button {
      width: 100%;
    }

    @media (min-width: 42rem) {
      .button {
        width: auto;
      }
    }
  }

  .box-legend {
    margin-top: 2rem;

     > p {
      margin-bottom: 1rem;
      font-style: italic;
      font-size: 1.1rem;
     }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/requestDetail/RequestDetailModalInvestDetail.vue